/**
 * Повторные приёмы/консультации не должны попадать в выбор на шаге записи.
 * Названия услуг приходят с бэкенда уже переведёнными (views services_ru/kk/en),
 * поэтому одного русского слова "повторный" недостаточно — в каждом языке
 * используется своё слово. Сопоставляем по ключевым словам всех трёх языков:
 *   ru: "повтор..."   (повторный приём / повторная консультация)
 *   kk: "қайтал..."   (қайталама қабылдау / қайталама консультация)
 *   en: "follow-up"   (follow-up appointment / follow-up consultation)
 */
const REPEAT_SERVICE_REGEX = /повтор|қайтал|follow[\s-]?up/i

export function isRepeatService(name: string | null | undefined): boolean {
  return REPEAT_SERVICE_REGEX.test(name || '')
}
